// src/lib/flats.ts — the development page's Flats tab and a flat's record: calls and colours. Labels (state, chip)
// come from the API; only how each state is coloured is decided here.
import { api } from './api';
import type { FlatChip, FlatRecord, FlatRow, FlatState, FlatsMeta } from '../types/api';

export interface FlatsFilters { chip?: FlatChip; floor?: string; unitType?: string; status?: string; buildingId?: string; q?: string }

export const flatsApi = {
  list: async (propertyId: string, f: FlatsFilters = {}) => {
    const r = await api.get<FlatRow[]>(`/properties/${propertyId}/flats`, { ...f, chip: f.chip === 'all' ? undefined : f.chip });
    return { rows: r.data, meta: r.meta as unknown as FlatsMeta };
  },
  record: async (unitId: string) => (await api.get<FlatRecord>(`/units/${unitId}/record`)).data,
};

/** The demo's FLAT_STATES colours, as theme-aware variables so they hold in dark mode. */
export const FLAT_STATE_COLOUR: Record<FlatState, string> = {
  LET: 'var(--status-good)',
  UNDER_NOTICE: 'var(--status-warning)',
  COMING_UP: 'var(--color-sky-600)',
  LET_AGREED: 'var(--color-violet-600)',
  ON_MARKET: 'var(--color-bronze-600)',
  VACANT: 'var(--status-neutral)',
  OFF_MARKET: 'var(--status-neutral)',
  UNDER_CONSTRUCTION: 'var(--status-serious)',
};

/** "Ground", "1st floor"… for a numeric floor. */
export function floorLabel(floor: number | null | undefined): string {
  if (floor === null || floor === undefined) return '—';
  if (floor === 0) return 'Ground';
  if (floor < 0) return `Basement ${-floor}`;
  const s = ['th', 'st', 'nd', 'rd'] as const;
  const v = floor % 100;
  return `${floor}${s[(v - 20) % 10] ?? s[v] ?? s[0]} floor`;
}

export const typeLabel = (t: string | null | undefined) => (t ? t.replace(/_/g, ' ').toLowerCase().replace(/^\w/, (c) => c.toUpperCase()) : '—');
